<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-md`"
    :headerText="headerText"
    :showCloseButton="false"
  >
    <template #footer>
      <div class="container-footer">
        <div>
          <button
            type="button"
            class="btn"
            @click="onClickClose">
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    headerText: {
      type: String,
      default: null,
    },
  },

  methods: {
    handleClose () {
      this.$emit('onClose')
    },
    onClickClose () {
      $(`#${this.id}`).modal('hide')
      this.$emit('onClose')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseAlertModal.vue